import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserModel} from '../../../models/User';
import {MixpanelService} from '../../../services/mixpanel.service';
import {CheckoutModalComponent} from '../../checkout/checkout.component';
import {AuthService} from '../../../services/auth.service';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Tiers} from '../../../models/SubscriptionsModels';
import {PartnerService} from '../../../services/partner.service';
import {Partners} from '../../../models/PartnersModel';


interface WaitlistContent {
  title:      string;
  imageSrc:   string;
  message:    string;
  buttonText: string;
}
export enum WaitlistMode {
    entry = 'entry',
    upgrade = 'upgrade'
}

@Component({
  selector: 'app-waitlist-modal',
  templateUrl: './waitlist-modal.component.html',
  styleUrls: ['./waitlist-modal.component.css']
})
export class WaitlistModalComponent implements OnInit{
  user: UserModel;
  @Input() isVisible = false;
  @Input() mode: WaitlistMode = WaitlistMode.entry;

  @Output() close  = new EventEmitter<void>();
  @Output() action = new EventEmitter<void>();
    protected readonly WaitlistMode = WaitlistMode;


    partner: Partners

  private contents: Record<WaitlistMode.entry | WaitlistMode.upgrade, WaitlistContent> = {
    entry: {
      title: `You're on the Basic Plan Waitlist! Estimated Access in 2-3 months.`,
      imageSrc: 'assets/images/modals/waitlist-skip-the-wait-800.webp',
      message: `Don’t miss deals to your dream destinations while you wait. Skip 1,500+ people in line and get instant access to every deal from your home airport. Cancel anytime.`,
      buttonText: 'Get Instant Access for $1'
    },
    upgrade: {
      title: `Skip the wait, and get instant access for $1`,
      imageSrc: 'assets/images/modals/waitlist-upgrade-800.webp',
      message: `You’re on the Basic Plan waitlist (Est. Access in 2-3 months). Get instant access to every deal from your home airport, plus SMS alerts and premium/business-class fares.`,
      buttonText: 'Try Premium+'
    }
  };

  constructor(public dialogService: DialogService, private auth: AuthService,  private mixpanel: MixpanelService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, private partnerService: PartnerService) {}
  ngOnInit(): void {
      this.auth.user$.subscribe(user =>{
          if(this.config.data){
              this.mode = this.config.data.mode
              this.isVisible = this.config.data.isVisible
          }
          if(user){
              this.user = user
              this.mixpanel.identify(user.id.toString());
          }
      });
      this.partnerService.setPartnerId(this.user?.upgradePartnerName)
      this.partnerService.partnerInfoSubject.subscribe(partner => {
          if (partner) {
              this.partner = partner;
          }
      });
  }

    get content(): WaitlistContent {
    return this.contents[this.mode];
  }
  onAction() {
    if (this.mode === 'entry') {
      this.mixpanel.track('Entry Waitlist Upgrade Modal Clicked');
    } else {
      this.mixpanel.track('Waitlist Upgrade Modal Clicked');
    }
      this.ref.close();
      setTimeout(() => {
          this.dialogService.open(CheckoutModalComponent, {
              data: {
                  plan: Tiers.PremiumPlus,
                  partner: this.partner,
                  onboardingRedirect: true,
                  trackingParams: {location: 'Waitlist Modal'},
                  user: this.user
              },
              width: '400px',
              breakpoints: {
                  '500px': '90vw'
              },
              showHeader: false,
              styleClass: 'checkout-dialog p-relative',
              dismissableMask: true,
              appendTo: document.body,
              contentStyle: {
                  borderRadius: '6px',
                  padding: '5px',
                  scrollbarWidth: 'none',
                  zIndex: 12000
              }
          });

      }, 200)
  }

  onClose() {
      this.ref.close();
    this.close.emit();
  }

  onBackdropClick(e: MouseEvent) {
    if ((e.target as HTMLElement).classList.contains('waitlist-overlay')) {
      this.onClose();
    }
  }

}
